import type { DeliveryMethodsEnum } from 'src/types';
import type { TranslateFunc } from 'src/components/translate';
import type { DeliveryMethodsConfig } from '../../types';

export const getDeliveryMethodsConfig = (): DeliveryMethodsConfig[] => [
  {
    translationDomain: 'product',
    translationString: 'variants.all',
    type: null,
  },
  {
    translationDomain: 'product',
    translationString: 'delivery-option.home-delivery',
    type: 'HOME',
  },
  {
    translationDomain: 'product',
    translationString: 'delivery-option.mailbox',
    type: 'MAILBOX',
  },
  {
    translationDomain: 'product',
    translationString: 'delivery-option.package-locker',
    type: 'PACKAGE_LOCKER',
  },
  {
    translationDomain: 'product',
    translationString: 'delivery-option.service-point',
    type: 'SERVICE_POINT',
  },
  {
    translationDomain: 'product',
    translationString: 'delivery-option.pickup-instore',
    type: 'INSTORE_PICKUP',
  },
];

export const getTranslation = (
  t: TranslateFunc,
  type: DeliveryMethodsEnum | null
) => {
  const deliveryMethodsConfig = getDeliveryMethodsConfig();
  const config = deliveryMethodsConfig.find(c => c.type === type);
  if (!config) {
    return null;
  }
  // @ts-expect-error -- Typed too loosely
  return t(config.translationDomain, config.translationString) as string;
};
